import React from "react";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import { object, string } from "prop-types";
import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import ShareDownloadsForm from "@src/ShareDownloadsForm/index";
import ShareDownloadsInfo from "@src/ShareDownloads/ShareDownloadsInfo";
import SiteLayout from "../../src/SiteLayout";
import { getSerialNumberInfo } from "../../src/services/serialNumber";
import resources from "../../locales/downloads-page";

const DownloadsPageHead = ({ regCode }) => {
	const [t] = useLocale("share-downloads");
	if (regCode.length > 0) {
		return (
			<PageMeta title={t("PAGE_TITLE")}>
				<PageMeta.Robots content={t("META_ROBOTS_CONTENT")} />
				<PageMeta.Canonical href={t("META_CANONICAL")} />
			</PageMeta>
		);
	}
	return <PageTitle title={t("PAGE_TITLE")} />;
};

const Downloads = ({ serialNumber, regCode }) => {
	return (
		<SiteLayout>
			<DownloadsPageHead regCode={regCode} />
			{serialNumber !== null ? (
				<ShareDownloadsInfo serialNumber={serialNumber} />
			) : (
				<ShareDownloadsForm regCode={regCode} key={Date.now()} /> // force re-render on page reload
			)}
		</SiteLayout>
	);
};

const regCode = ({ query }) => query.r ?? "";

Downloads.getInitialProps = propsResolver({
	serialNumber: context => getSerialNumberInfo(context, regCode(context)),
	regCode,
});

Downloads.propTypes = {
	serialNumber: object, // eslint-disable-line react/forbid-prop-types
	regCode: string,
};

DownloadsPageHead.propTypes = {
	regCode: string,
};

export default pipe(Downloads, WithLocale({ resources }));
